import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { breakpoints, colors, zIndex } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import LanguageSelector from './language-selector'

const Wrapper = styled.div`
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: auto;
  z-index: ${zIndex.footer};
  background-color: ${colors.white};
`

const FooterContainer = styled.div`
  background-color: #0e0303;
  background-image: -webkit-linear-gradient(270deg, #303030, #101010),
    -webkit-linear-gradient(270deg, #101010, #101010);
  background-image: linear-gradient(180deg, #303030, #101010),
    linear-gradient(180deg, #101010, #101010);

  @media screen and (max-width: 890px) {
    padding: 0 20px;
  }
`

const InnerFooterContainer = styled.div`
  margin: 0 auto;
  max-width: 1096px;
  padding: 12px 30px;

  @media screen and (max-width: 890px) {
    padding: 12px 0;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: initial;
    width: 100%;
  }
`

const SubFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CopyrightText = styled.p`
  color: ${colors.white};
  font-size: 14px;
  text-align: left;
  line-height: 18px;
  margin: 10px 0px;

  @media screen and (max-width: ${breakpoints.smallPhone}) {
    font-size: 12px;
  }
`

const currentYear = new Date().getFullYear()

const Footer: React.VoidFunctionComponent = () => {
  const { t } = useTranslation()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const copyrightText = displayMobile
    ? `Liv Strategies Inc. © ${currentYear}`
    : `Liv Strategies Inc. © ${currentYear} | ` +
      `Vancouver, BC | ${t('b.footer.view.apartments_for_rent.text', 'Apartments for Rent')}`

  return (
    <Wrapper>
      <FooterContainer>
        <InnerFooterContainer>
          <SubFooter>
            <CopyrightText>{copyrightText}</CopyrightText>
            <LanguageSelector />
          </SubFooter>
        </InnerFooterContainer>
      </FooterContainer>
    </Wrapper>
  )
}

export default Footer
